import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  mediaContainer: {
    width: '100%',
    maxWidth: 'auto',
    minWidth: '46%',
    [theme.breakpoints.down('md')]: {
      minWidth: 462,
      marginRight: 'auto'
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      width: '100%',
      maxWidth: '100%'
    }
  },
  currentMediaContainer: {
    width: 'auto',
    maxWidth: 'auto',
    minWidth: '70%',
    [theme.breakpoints.down('md')]: {
      paddingTop: 'unset'
    }
  },
  currentMediaContainerSmall: {
    width: '100%',
    minWidth: 'unset',
    maxWidth: 'unset'
  },
  paperCurrentMedia: {
    width: 'auto',
    minWidth: 460,
    height: 'auto',
    minHeight: 320,
    padding: '20px 25px',
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },
  paper: {
    width: '100%',
    height: 320,
    padding: '20px 25px',
    marginBottom: 30,
    [theme.breakpoints.up('xs')]: {
      maxWidth: 460,
      height: 354
    }
  },
  uploadPdfLabel: {
    padding: '20px 2px 5px'
  },
  uploadContainer: {
    cursor: 'pointer',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: '#979797',
    height: 155,
    maxWidth: 300,
    width: '100%'
  },
  selectFileLabel: {
    height: 42,
    margin: 'auto',
    border: 'solid 1px #979797',
    padding: '10px 20px',
    background: 'rgb(229 229 229)',
    borderRadius: '2px',
    boxShadow: '0px 0px 0.5px 0.5px rgb(151, 151, 151)'
  },
  labelMaximumSize: {
    color: '#4A4A4A',
    fontSize: 12,
    paddingTop: 8
  },
  selectedFileContainer: {
    height: 290
  },
  selectedFileNameContainer: {
    border: 'solid 1.5px #979797',
    padding: 4,
    marginTop: 40
  },
  attachFileIcon: {
    margin: 0,
    marginRight: 6,
    fontSize: 19,
    marginTop: 2,
    transform: 'rotate(-30deg)'
  },
  fileNameContainer: {
    display: 'flex',
    alignItems: 'center',
    '& ::first-letter': {
      textTransform: 'capitalize'
    }
  },
  fileNameLabel: {
    fontSize: 15
  },
  deleteSelectedFileContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  deleteSelectedFileLink: {
    color: '#4A4A4A',
    minWidth: 41,
    padding: 0,
    '& > span': {
      padding: 0
    },
    '&:hover': {
      textDecoration: 'underline',
      background: 'unset'
    }
  },
  error: {
    fontSize: '12px',
    color: '#ba0800'
  },
  currentMediaFileName: {
    fontSize: 14
  },
  fileInput: {
    display: 'none'
  },
  deleteContainerPdf: {
    width: 130
  },
  deleteContainerLink: {
    width: 150
  },
  deleteIcon: {
    width: 20,
    height: 20,
    cursor: 'pointer'
  },
  pdfIcon: {
    width: 109,
    height: 109,
    marginBottom: 6
  },
  linkIcon: {
    width: 109,
    height: 109,
    marginBottom: 3,
    marginTop: 3
  },
  pdfImageContainer: {
    textAlign: 'center'
  },
  mt_30: {
    marginTop: 30
  },
  errorUrl: {
    minHeight: 20,
    fontSize: '12px',
    color: '#ba0800'
  },
  mediaItemPanel: {
    minWidth: '180px',
    width: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  mediaItemPanelSmall: {
    maxWidth: 160
  }
}))
